/**
 * Last-resort gift-card `supplier_id` when building booking/embedded lines and neither
 * the cart line, embedded `supplierId` query, nor subdomain supplier data yields an id.
 * Normal booking/embedded checkout should use the real supplier from
 * `resolveBookingGiftcardSupplierContext`; this constant is only that final fallback.
 */
export const KONFETTI_GIFTCARD_SUPPLIER_ID = 'z38lrx'
